import { ChangeLogEntry } from '../../../types/change_logs';
import { Item } from '../../../types/item';

export interface ChangeLogsState {
  history: ChangeLogEntry[];
  items: Item[];
  fetchingChangeLogs: boolean;
  fetchingMoreChangeLogs: boolean;
  fetchingItems: boolean;
  error: string | null;
}

const initialState: ChangeLogsState = {
  history: [],
  items: [],
  fetchingChangeLogs: false,
  fetchingMoreChangeLogs: false,
  fetchingItems: false,
  error: null,
};

export default function changeLogsReducer(state = initialState, action: any): ChangeLogsState {
  switch (action.type) {
    case 'FETCH_CHANGE_LOGS_HISTORY_PENDING':
      return {
        ...state,
        fetchingChangeLogs: action.meta?.page === 1,
        fetchingMoreChangeLogs: action.meta?.page > 1,
        history: action.meta?.page === 1 ? [] : state.history,
        error: null,
      };

    case 'FETCH_CHANGE_LOGS_HISTORY_FULFILLED': {
      const response: ChangeLogEntry[] = action.payload.data;
      const page = action.meta?.page || 1;

      return {
        ...state,
        fetchingChangeLogs: false,
        fetchingMoreChangeLogs: false,
        history: page === 1 ? response : [...state.history, ...response],
        error: null,
      };
    }

    case 'FETCH_CHANGE_LOGS_HISTORY_REJECTED':
      return {
        ...state,
        fetchingChangeLogs: false,
        fetchingMoreChangeLogs: false,
        error: action.payload?.message || 'Failed to fetch change logs history',
      };

    case 'CLEAR_CHANGE_LOGS_HISTORY':
      return {
        ...initialState,
      };

    case 'FETCH_CHANGE_LOG_ITEMS_PENDING':
      return {
        ...state,
        fetchingItems: true,
        error: null,
      };

    case 'FETCH_CHANGE_LOG_ITEMS_FULFILLED': {
      return {
        ...state,
        fetchingItems: false,
        items: action.payload.data,
        error: null,
      };
    }

    case 'FETCH_CHANGE_LOG_ITEMS_REJECTED':
      return {
        ...state,
        fetchingItems: false,
        error: action.payload?.message || 'Failed to fetch change log items',
      };

    default:
      return state;
  }
}
